//xxxxx:8081/dashboard/index
const dashboardRouter = [
    {
        path:'',
        name:'dashboard',
        redirect: { name: 'dashboard-overview' },
        children:[ 
            {
                path:'index',
                name:'dashboard-overview',
                component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/index.vue'),
            },
            {
                path:'recipe',
                name:'dashboard-recipe-index',
                // redirect: { name: 'dashboard-recipe-index' },
                component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/recipe/index.vue'),
                children:[
                    {
                        path:'detail/:id',
                        name:'dashboard-recipe-detail',
                        component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/recipe/detail.vue')
                    },{
                        path:'edit/:id',
                        name:'dashboard-recipe-edit',
                        component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/recipe/edit.vue')
                    }
                ],
            },{
                path:'careWork',
                name:'dashboard-careWork-index',
                redirect: { name: 'dashboard-careWork-kitchen' },
                component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/careWork/index.vue'),
                children:[
                    {
                        path:'kitchen',
                        name:'dashboard-careWork-kitchen',
                        component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/careWork/kitchen.vue')
                    },{
                        path:'recipes',
                        name:'dashboard-careWork-recipes',
                        component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/careWork/recipes.vue')
                    },{
                        path:'nurse',
                        name:'dashboard-careWork-nurse',
                        component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/careWork/nurse.vue')
                    },{
                        path:'packMedicine',
                        name:'dashboard-careWork-packMedicine',
                        component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/careWork/packMedicine.vue')
                    },{
                        path:'giveMedication',
                        name:'dashboard-careWork-giveMedication',
                        component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/careWork/giveMedication.vue')
                    }
                ]
            },{
                path:'careAnimal',
                name:'dashboard-careAnimal-index',
                component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/careAnimal/index.vue'),
                redirect: { name: 'dashboard-careAnimal-empty' },
                children:[{
                    path:'',
                    name:'dashboard-careAnimal-empty',
                    component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
                    props: { message: '請點選左側列表檢視照養紀錄' }
                },{
                    path:'detail/:id',
                    name:'dashboard-careAnimal-detail',
                    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/careAnimal/detail.vue'),
                }]
            }
        ]
    },
  ]
  export default dashboardRouter